module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.18.0.0.box.183.556.903.394.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.18.0.0.box.183.556.440.38.q.80"
    }
  }, [_vm._v("CHAPTER ONE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.18.0.1.box.378.777.708.173.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("River ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Ridge")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bayous ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Burnt ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Canes ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.18.1.0.box.380.1142.1150.289.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "4em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.18.1.0.box.380.1142.1150.232.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _vm._v("Vital ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("river, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("known ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Indians ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Father ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Waters. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Strong ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mississippi, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("likened ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("an ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("army ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("invasion ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.1.0"
    }
  }), _vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("land. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("But ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("landbearer ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mississippi ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("guise ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("too ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("often ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("forgot: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Heavy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("runs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alluvial ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("river, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pregnant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("land ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("seeking ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("born ")]), _vm._v(". . .")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "right",
      "margin-left": "8em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.18.1.1.box.534.1386.995.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.2.0"
    }
  }), _vm._v("Hodding Carter, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Man ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("River: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mississippi ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.2.0.box.178.1493.1350.1025.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.2.0.box.181.1493.1347.144.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("centuries ")]), _vm._v("many tributaries have nourished the Mississippi River as it meanders some 2,348 miles from Lake Itasca in Minnesota to the Gulf of Mexico.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.2.1.box.180.1657.1348.209.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.1.0"
    }
  }), _vm._v("The insatiable stream has given generously of what it has received—countless tons of water and waste, silt and sand, loam and vegetation. Sediment, dropped as the river merged with the Gulf of Mexico, formed the St. Bernard delta in ages past.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.2.2.box.179.1878.1348.257.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.2.0"
    }
  }), _vm._v("As it coursed gulfwards, the river at various times split into channels called distributaries, many of which it later bypassed. The most noticeable and noteworthy of abandoned distributaries, within what geologists call the Pontchartrain Basin, is the Bayou Metairie-Gentilly-Sauvage system.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.2.3.box.178.2148.1348.370.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.3.0"
    }
  }), _vm._v("Metairie Bayou originated some six centuries before the Christian era, when the roiling Mississippi crossed its own natural banks between present-day Kenner and Little Farms. River silt borne over low banks built up a ridge on each side of the bayou and its continuation through Gentilly Bayou and Bayou Sauvage. The adjacent shallow waters of swamp and marsh also received sediments which spread north towards what is now Lake Pontchartrain and eastward as far as the Rigolets."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.19.1.0.box.180.287.1348.201.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _vm._v("\nThe ridges or natural levees began at the outskirts of Kenner, where they are still about a mile wide and seven feet high. They narrowed gradually until they finally lost surface expression in the vicinity of Chef Menteur Pass.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.1.0.box.180.287.1352.2072.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.1.box.181.506.1348.485.q.60"
    }
  }, [_vm._v("Metairie Bayou began dying of thirst before the white man arrived in Louisiana. As it pushed gulfwards, the bayou lengthened its channel, reduced its fall per mile and consequent velocity, filling its own channel as do all river outlets, natural or artificial. Early settlers found remnants of the bayou, which they leveed off from the river and deprived of water supply. Exactly when the bayou system died is unknown, but there is no record of its being navigated by sizeable boats. Prehistoric Indians, though, probably could and did travel on it in their dugouts.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.2.box.183.1003.1347.479.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.2.0"
    }
  }), _vm._v("Bayou St. John, sometimes called an interloper between Bayou Metairie and Bayou Gentilly, is actually a channel formed by water impounded within the large area of the future City of New Orleans and the ridge. Bayou St. John has also been attributed to a shallow geological fault or fracture. In the judgment of some engineers, Metairie Bayou and Bayou Gentilly-Sauvage flowed as one stream approximately where Grand Route St. John is today. If such was the case, then the bend in Bayou St. John between Esplanade Avenue and Harding Drive may have been part of Metairie Bayou.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.3.box.184.1494.1348.535.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.3.0"
    }
  }), _vm._v("The rich alluvial Metairie-Gentilly Ridge has supported masses of reeds, thickets of cane, tall grasses, palmettos, and trees of the beech family such as live, water, pin, and willow oak. Southern Cottonwood, black willow, hackberry, magnolia, and Southern sweet bay also have long thrived on the ridge. When the aborigines and, later, French explorers penetrated the adjacent areas, they had to trudge through spongy marshes, wet lands, and stands of sweetgum, redgum, and liquidambar. The cypress, tupelo, and hickory swamps had an aspect quite similar to some of the terrain still viewed by the motorist as he drives along Interstate Highway 10 between Kenner and Laplace.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.4.box.186.2040.1346.319.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.4.0"
    }
  }), _vm._v("The first recorded encounter between white man and red man in the lower delta took place in 1682 when Robert Cavelier de La Salle came down the Mississippi on his way to the Gulf. Accompani"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _vm._v("ed by 22 armed Frenchmen, 31 friendly Indians including 10 squaws and 3 children, a notary named Jacques de La Métairie"), _c('span', {
    staticClass: "gstxt_sup"
  }, [_vm._v("1")]), _vm._v(" and the Recollect"), _c('sup', [_vm._v("2")]), _vm._v(" missionary Father Zenobius Membré, La Salle had entered the Mississippi"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.1.0.box.222.296.1341.375.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _vm._v("\nfrom the Illinois River on February 13. The Indians of the time called the Mississippi by various descriptive names of their tribal tongues: the Malbrancia, Misisipi, Michi Sepe, Chucagua, Tamalisieu, Tapatu, ad Mico, and Ochechiton. La Salle referred to it as the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Colbert")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("after Jean-Baptiste Colbert, Marquis de Seignelay, French minister of marine, and later, minister of state for King Louis XIV. The river would long appear on maps as "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Le ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Fleuve ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Saint-Louis")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("the St. Louis River.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  }), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.19.2.0.box.187.2393.1347.121.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.0.box.187.2393.1347.79.q.60"
    }
  }, [_c('sup', [_vm._v("1")]), _vm._v(" As will be indicated in Chapter Five, the place named Metairie probably did not originate with the notary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.1.box.225.2485.904.29.q.70"
    }
  }, [_c('sup', [_vm._v("2")]), _vm._v(" The Recollects were a branch of the Franciscan Order.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.20.1.0.box.222.296.1341.541.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.1.box.222.684.1340.153.q.60"
    }
  }, [_vm._v("The La Salle expedition passed in early April the banks of the Mississippi at or near the head of the Metairie distributary. La Métairie recounts on April 3,1682:")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.20.2.0.box.263.867.1259.858.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.2.0.box.263.867.1259.858.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.2.0"
    }
  }), _vm._v("At ten in the morning we saw in the canes thirteen or fourteen pirogues. M. de La Salle debarked with some of his company. We noticed a number of traces; a little farther down, we saw some Savages who were fishing but who, having detected us, left the place and fled. We touched ground on the edge of a marsh caused by the flooding of the river. M. de La Salle sent two Frenchmen on reconnaissance and then two Savages who reported that there was a village close by; that, to reach it, one had to cross this whole marsh covered with canes; that they had been attacked with flying arrows by those in the place who did not dare engage themselves in the marsh and had fallen back, despite the fact that neither the French nor the Savages with them wished to fire their arms, according to the instructions that they were to do no such thing except in an emergency. Soon we heard the beating of a drum in the village, and the shouts and abusive cries with which these barbarians are accustomed to attack [their enemies]. We heard them for three or four hours, and since we could not camp in the marsh, [after] seeing no one and hearing nothing more we embarked.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.3.0.box.224.1750.1342.586.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.3.0.box.224.1750.1342.586.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.3.0"
    }
  }), _vm._v("The expedition continued downstream for three days before reaching the passes leading into the Gulf. On April 9, La Salle, in the name of his sovereign, took official possession of \"this country of Louisiana, the seas, harbors, ports, bays, adjacent straits, and all the nations, people, provinces, cities, towns, villages, mines, minerals, fisheries, streams, and rivers within its expanse.\" La Métairie composed the act of possession, writing that La Salle, \"having said that His Majesty, as eldest son of the Church, would add to his crown no nation where His principal care would not tend towards the establishment of the Christian religion,\" had a large cross erected on the spot. Father Membré\" led in the singing of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Te ")]), _c('i', [_vm._v("Deum")]), _vm._v(","), _c('span', {
    staticClass: "gstxt_sup"
  }, [_vm._v("3")]), _vm._v(" the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Vexilla ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Regis")]), _vm._v(","), _c('span', {
    staticClass: "gstxt_sup"
  }, [_vm._v("4")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("and the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.1.0.box.125.298.1345.100.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Domine, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("salvum ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fac ")]), _c('i', [_vm._v("regem")]), _vm._v("."), _c('sup', [_vm._v("5 ")]), _vm._v("Louisiana began on a resoundingly religious note.")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.20.4.0.box.227.2364.1340.171.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.4.0.box.227.2364.1339.78.q.60"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.4.0"
    }
  }), _vm._v("3")]), _vm._v(" The most famous non-biblical hymn in the Western Church to express thanksgiving; the text dates back to the Fifth Century.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.4.1.box.230.2456.1337.79.q.50"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.5.0"
    }
  }), _vm._v("4")]), _vm._v(" The hymn concerning the mystery of the cross; it was written by Venantius Fortunatus (530-609).")]), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.21.1.0.box.125.298.1350.1124.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.1.box.127.408.1348.580.q.60"
    }
  }, [_vm._v("Two years later, during an abortive attempt to enter the Mississippi from its mouth, La Salle died at the hands of his own men. Father Anastase Douay, who had accompanied the explorer, found his way, afoot and by canoe, back to Canada from Texas. Fifteen years later, the missionary still had the stamina to join the 1699 expedition of Pierre Le Moyne, Sieur d'Iberville, up the Mississippi. It was Father Douay, more than any other member of the Iberville party, who could confidently assure the leader that he had indeed entered the \"river of de La Salle\" at its mouth. As the historian J. B. Bénard de La Harpe notes, \"Father Anastase recognized it because of the turbulence of its waters.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.130.1009.1343.413.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.2.0"
    }
  }), _vm._v("On March 3, 1699, Father Anastase celebrated, with Iberville and his men as a congregation, the first Mass on Louisiana soil. A few miles farther up the river, he offered Mass the next day, Ash Wednesday, when he also blessed and distributed ashes. By the following Saturday, March 7, the explorers encamped somewhere within the future metropolitan area, since they were then thirty leagues"), _c('sup', [_vm._v("6")]), _vm._v(" up the river. A narrator of the voyage tells of their encounter with the local Indians on that date:")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.2.0.box.170.1473.1264.751.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.2.0.box.170.1473.1264.751.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.2.0.0"
    }
  }), _vm._v("At nine o'clock, in ranging along the river we saw three buffaloes lying down on the bank. We landed five men to go in pursuit of them, which they could not do, as they soon got lost in the thick forest and canebrakes. A short time after, in turning a point, we saw a canoe manned by two Indians, who took to land the moment they saw us and concealed themselves in the woods. A little farther on we saw five more who executed the same manoeuvre, with the exception of one, who waited for us at the brink of the river. We made signs to him. M. d'Iberville gave him a knife, some beads and some trinkets. In exchange he gave us some dried boar's meat. M. d'Iberville commanded all o"), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.3.0.0"
    }
  }), _vm._v("f our men to go on board the longboats for fear of intimidating him, and made signs to him to recall his comrades. They came singing their song of peace, extending their hands towards the sun and rubbing their stomachs, as a sign of admiration and joy. After joining us they placed their hands upon their breasts and extended their arms over"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.22.1.0.box.225.336.1257.97.q.50"
    }
  }, [_vm._v("\nour heads as a mark of friendship. M. d'Iberville asked them, by signs, if their village was far off. They told him it was five days' journey hence.")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.21.3.0.box.128.2282.1345.165.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.3.0.box.168.2282.544.36.q.70"
    }
  }, [_c('sup', [_vm._v("5 ")]), _vm._v("Literally, \"Lord, save the King.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.3.1.box.128.2331.1345.116.q.50"
    }
  }, [_c('sup', [_vm._v("6 ")]), _vm._v("A league is an ancient, variable linear measurement. By French computation, a marine league is approximately three miles; a land league about 20 percent shorter.")]), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.22.1.0.box.225.336.1257.97.q.50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.22.2.0.box.181.468.1341.810.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.0.box.184.468.1338.211.q.60"
    }
  }, [_vm._v("On Sunday, March 8, Father Anastase celebrated Mass, presumably on Jefferson Parish soil or slightly above it. It is probable that Indians who were accustomed to traversing the Metairie Ridge made their initial contacts with a missionary at this time.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.1.box.182.693.1340.374.q.60"
    }
  }, [_vm._v("Iberville did not descend the Mississippi River to the Gulf during his first 1699 expedition. At the suggestion of his Indian guides, as well as his brother Bienville's newly-found friends among the Bayougoula and Mougoulacha Indians, then settled above present-day Donaldsonville, Iberville gained the Gulf Coast by way of the Ascantia River (later named the Iberville, and still later, Manchac Bayou) and through Lakes Maurepas and Pontchartrain.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.2.box.181.1079.1341.199.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.3.0"
    }
  }), _vm._v("On a subsequent exploratory voyage, he re-entered Lake Pontchartrain from the Gulf by way of the Rigolets. One member of this reconnoitering contingent, André Pénicaut, a ship's carpenter, records that:")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.22.3.0.box.222.1324.1259.705.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.3.0.box.222.1324.1259.705.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.0.0"
    }
  }), _vm._v("We found a big lake which M. deBienville named Lake Pontchartrain. This lake is twenty-eight leagues in circumference and seven across. Its mouth at the entrance is a quarter of a league across from right to left, and both sides of this entrance are covered with shells in such great quantities that they form banks; accordingly it was given the name Pointe-aux-Coquilles. After one enters this watercourse and sails upward for a league and a half from the entrance, he finds on his left a point called Pointe-aux-Herbes; here we sheltered our longboats, because this lake is so shallow that boats are always being lost here in rough weather. Six leagues farther up the lake, a small river flows into it which is called, in savage, Choupitcatcha; the French call it today Rivière d'Orléans because afterwards (as will be shown at the proper time) there was built near this river, one league away from the lake, the town of New Orleans.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.4.0.box.184.2058.1339.371.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.4.0.box.184.2058.1339.371.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.1.0"
    }
  }), _vm._v("Before reaching the Rivière d'Orléans (Bayou St. John) the explorers had passed four bayous which belong to the Metairie distributary system: Bayou de Lassaire"), _c('sup', [_vm._v("7")]), _vm._v(" near the Rigolets and Lake St. Catherine; Stump Bayou, below Pointe-aux-Herbes; Bayou Pecoin slightly to the west of the Pointe, perhaps the place which fishermen today know as Irish Bayou; and Turtle Bayou, a little to the southwest. After leaving Bayou St. John, they observed at close range the south shore of"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.1.0.box.151.347.1348.361.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  }), _vm._v("\nLake Pontchartrain which is now part of Jefferson Parish. At a distance of some five leagues from Bayou St. John, they came to a \"stagnant body of water that the savages called "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bayouque")]), _vm._v(",\" either Bayou Piquant or Bayou LaBranche according to some authorities."), _c('sup', [_vm._v("8")]), _vm._v(" Both are now in St. Charles civil parish, a short distance west of Kenner. Referring either to Bayou Piquant or Bayou LaBranche, Pénicaut continues:")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.22.5.0.box.223.2481.350.38.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.5.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.5.0.box.223.2481.350.38.q.60"
    }
  }, [_c('sup', [_vm._v("7")]), _vm._v(" Also spelled Lesaire.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.23.1.0.box.151.347.1348.361.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.23.2.0.box.192.754.1267.440.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.2.0.box.192.754.1267.440.q.60"
    }
  }, [_vm._v("We made camp near this place ["), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bayouque")]), _vm._v("]"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("because the savages who were guiding us made us understand that we should go by way of it to the Missicipy River. On the morning of the next day, having left our longboats in the bay, we set out on foot to make our way to the river bank. For three quarters of a league we crossed through a wood filled with cypress . . . coming out of this wood, we entered some tall reeds, or canes . . . After crossing through these canes for a quarter of a league, we reached the bank of the Missicipy. . . . At this place its banks are covered with canes")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.3.0.box.146.1237.1351.693.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.3.0.box.146.1237.1351.480.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.1.0"
    }
  }), _vm._v("Later, some unknown explorer noticed a clearing near the place where Pénicaut and his companions viewed the Mississippi from its eastern shore. The place received the name of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cannes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Brûlées")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("literally, \"Burnt Canes.\" As the narrator of the first upriver expedition of Iberville noted, the Indians used to clear the land by setting fire to the canes along the banks \"either to drive out the game or to obtain better access to aim and shoot at us.\" At any rate, the name "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cannes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Brûlées")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("became a landmark for early French settlers, a point of reference for mapmakers, and the oldest identified site in East Jefferson.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.3.1.box.149.1727.1344.203.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.2.0"
    }
  }), _vm._v("It is also the original and long-lasting name of the City of Kenner. The city's lower limits are still defined by the area where, long ago, the Mississippi River crossed its natural levee to give birth to Metairie Bayou, Ridge and distributary system.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.23.4.0.box.182.2469.923.39.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.4.0.box.182.2469.923.39.q.60"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.3.0.0"
    }
  }), _vm._v("8")]), _vm._v(" Others contend that it was the extinct Bayou Tigouyou.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b5385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0005.vue
// module id = 60
// module chunks = 0